module.exports = __webpack_public_path__ + "img/load-5-3.016d9322.png";